import { request } from "@/common"
import { makeAutoObservable } from "mobx";
import { useEffect, useState } from "react"

let audio: HTMLAudioElement

class AigcBgmStore {
  playingID = ''

  audio: HTMLAudioElement;

  constructor() {
    makeAutoObservable(this)
  }

  setPlayingID(id) {
    this.playingID = id
  }

  pauseAudio = () => {
    if (!audio) {
      return;
    }

    audio.pause();
    this.setPlayingID('')
  }

  audioLoadAndPlay = (src) => {
    if (!audio) {
      audio = new Audio();
    }
    audio.src = src;
    audio.preload = 'auto';
    audio.autoplay = true;
    audio.addEventListener('ended', () => {
      this.setPlayingID('')
    }, { once: true })
  }
  onPlay = (item: { id: string, voice_url: string }) => {
    if (!item.voice_url) {
      return;
    }
    if (item.id === this.playingID) {

      this.pauseAudio()
      return
    }
    this.setPlayingID(item.id)
    this.audioLoadAndPlay(item.voice_url);
  }
}

export const aigcBGMStore = new AigcBgmStore;